unit View.Sincronizacao_Logs.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UHelperServer;

type
  TFViewSincronizacao_LogsList = class(TForm)
    btNew: TButton;
    Sincronizacao_LogsDataset: TXDataWebDataSet;
    Sincronizacao_LogsDatasetid: TIntegerField;
    Sincronizacao_LogsDatasetaliado_id: TIntegerField;
    Sincronizacao_LogsDatasetdata_base_id: TIntegerField;
    Sincronizacao_LogsDatasetsincronizacao_service_id: TIntegerField;
    Sincronizacao_LogsDatasetultima_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetinicio_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetfim_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetsincronizacao_erro: TStringField;
    Sincronizacao_LogsDatasetinclusao: TDateTimeField;
    Sincronizacao_LogsDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda: TDateTimeField;
    Sincronizacao_LogsDatasetversao_client: TStringField;
    Sincronizacao_LogsDatasetsincronizacao_servicerota: TXDataWebDatasetField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_LogsList: TFViewSincronizacao_LogsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_LogsList }

procedure TFViewSincronizacao_LogsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewSincronizacao_LogsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_LogsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_LogsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_LogsList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewSincronizacao_LogsList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewSincronizacao_LogsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewSincronizacao_LogsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewSincronizacao_LogsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Sincronizacao_LogsDataset.Connection.Model.DefaultSchema.FindEntityType(Sincronizacao_LogsDataset.EntitySetName),
      Sincronizacao_LogsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewSincronizacao_LogsList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'tempo_sincronizacao' then
  begin
    AValue := THelperServer.GetTempoSincronizacao(Sincronizacao_LogsDataset.FieldByName('inicio_sincronizacao').AsString,
      Sincronizacao_LogsDataset.FieldByName('fim_sincronizacao').AsString);
  end
end;

procedure TFViewSincronizacao_LogsList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Sincronizacao_LogsDataset, lcPaginator,
    lbPaginationInfo);

  if THelperServer.FQuery <> '' then
  begin
    FGridPlugin.FDatasetPlugin.FFilterPadrao := THelperServer.FQuery;
    THelperServer.FQuery := '';
  end;

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'sincronizacao_erro desc, ultima_sincronizacao desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewSincronizacao_LogsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.sincronizacao_logs.list.pagination.info');
  btNew := TButton.Create('view.sincronizacao_logs.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.sincronizacao_logs.list.table');
  cbPageSize := TComboBox.Create('view.sincronizacao_logs.list.cbPageSize');
  edSearch := TEdit.Create('view.sincronizacao_logs.list.search');
  lcPaginator := TListControl.Create('view.sincronizacao_logs.list.pagination');
  Sincronizacao_LogsDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_LogsDatasetid := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetaliado_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetdata_base_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_service_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetultima_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetinicio_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetfim_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_erro := TStringField.Create(Self);
  Sincronizacao_LogsDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetultima_verificacao_retaguarda := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetversao_client := TStringField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_servicerota := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Sincronizacao_LogsDataset.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetid.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetaliado_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetdata_base_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_service_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetultima_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetinicio_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetfim_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_erro.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetultima_verificacao_retaguarda.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetversao_client.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_servicerota.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_LogsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sincronizacao_service_id';
      Title := 'sincronizacao_service_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sincronizacao_service.rota';
      Title := 'sincronizacao_rota';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'versao_client';
      Title := 'versao_client';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ultima_verificacao_retaguarda';
      Title := 'ultima_verificacao_retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ultima_sincronizacao';
      Title := 'ultima_sincronizacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inicio_sincronizacao';
      Title := 'inicio_sincronizacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fim_sincronizacao';
      Title := 'fim_sincronizacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'tempo_sincronizacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sincronizacao_erro';
      Title := 'sincronizacao_erro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Sincronizacao_LogsDataset.SetParentComponent(Self);
    Sincronizacao_LogsDataset.Name := 'Sincronizacao_LogsDataset';
    Sincronizacao_LogsDataset.EntitySetName := 'Sincronizacao_Logs';
    Sincronizacao_LogsDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_LogsDataset.Left := 72;
    Sincronizacao_LogsDataset.Top := 144;
    Sincronizacao_LogsDatasetid.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetid.Name := 'Sincronizacao_LogsDatasetid';
    Sincronizacao_LogsDatasetid.FieldName := 'id';
    Sincronizacao_LogsDatasetid.Required := True;
    Sincronizacao_LogsDatasetaliado_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetaliado_id.Name := 'Sincronizacao_LogsDatasetaliado_id';
    Sincronizacao_LogsDatasetaliado_id.FieldName := 'aliado_id';
    Sincronizacao_LogsDatasetaliado_id.Required := True;
    Sincronizacao_LogsDatasetdata_base_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetdata_base_id.Name := 'Sincronizacao_LogsDatasetdata_base_id';
    Sincronizacao_LogsDatasetdata_base_id.FieldName := 'data_base_id';
    Sincronizacao_LogsDatasetdata_base_id.Required := True;
    Sincronizacao_LogsDatasetsincronizacao_service_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_service_id.Name := 'Sincronizacao_LogsDatasetsincronizacao_service_id';
    Sincronizacao_LogsDatasetsincronizacao_service_id.FieldName := 'sincronizacao_service_id';
    Sincronizacao_LogsDatasetsincronizacao_service_id.Required := True;
    Sincronizacao_LogsDatasetultima_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetultima_sincronizacao.Name := 'Sincronizacao_LogsDatasetultima_sincronizacao';
    Sincronizacao_LogsDatasetultima_sincronizacao.FieldName := 'ultima_sincronizacao';
    Sincronizacao_LogsDatasetultima_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetinicio_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetinicio_sincronizacao.Name := 'Sincronizacao_LogsDatasetinicio_sincronizacao';
    Sincronizacao_LogsDatasetinicio_sincronizacao.FieldName := 'inicio_sincronizacao';
    Sincronizacao_LogsDatasetinicio_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetfim_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetfim_sincronizacao.Name := 'Sincronizacao_LogsDatasetfim_sincronizacao';
    Sincronizacao_LogsDatasetfim_sincronizacao.FieldName := 'fim_sincronizacao';
    Sincronizacao_LogsDatasetfim_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetsincronizacao_erro.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_erro.Name := 'Sincronizacao_LogsDatasetsincronizacao_erro';
    Sincronizacao_LogsDatasetsincronizacao_erro.FieldName := 'sincronizacao_erro';
    Sincronizacao_LogsDatasetsincronizacao_erro.Size := 65536;
    Sincronizacao_LogsDatasetinclusao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetinclusao.Name := 'Sincronizacao_LogsDatasetinclusao';
    Sincronizacao_LogsDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_LogsDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetalteracao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetalteracao.Name := 'Sincronizacao_LogsDatasetalteracao';
    Sincronizacao_LogsDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_LogsDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda.Name := 'Sincronizacao_LogsDatasetultima_verificacao_retaguarda';
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda.FieldName := 'ultima_verificacao_retaguarda';
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Sincronizacao_LogsDatasetversao_client.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetversao_client.Name := 'Sincronizacao_LogsDatasetversao_client';
    Sincronizacao_LogsDatasetversao_client.FieldName := 'versao_client';
    Sincronizacao_LogsDatasetversao_client.Size := 255;
    Sincronizacao_LogsDatasetsincronizacao_servicerota.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_servicerota.Name := 'Sincronizacao_LogsDatasetsincronizacao_servicerota';
    Sincronizacao_LogsDatasetsincronizacao_servicerota.FieldKind := fkCalculated;
    Sincronizacao_LogsDatasetsincronizacao_servicerota.FieldName := 'sincronizacao_service.rota';
    Sincronizacao_LogsDatasetsincronizacao_servicerota.Calculated := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Sincronizacao_LogsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Sincronizacao_LogsDataset.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetid.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetaliado_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetdata_base_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_service_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetultima_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetinicio_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetfim_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_erro.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetultima_verificacao_retaguarda.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetversao_client.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_servicerota.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
